import { isHttpError } from '@/http';
import { getHttpErrorCode } from './get-http-error-code';

// 409 codes the onboarding and payment endpoints use to say the process has
// moved past the call. The answer is to re-read /status and jump there.
const ONBOARDING_CONFLICT_CODES = [
	'ALREADY_PAID',
	'ONBOARDING_ALREADY_ADVANCED',
	'UNDER_REVIEW',
	'NO_ACTIVE_CERTIFICATE',
	// new-certificate / data-enrichment for another ulid while one is in review.
	'PROCESS_UNDER_REVIEW',
];

export function isOnboardingConflict(error: unknown): boolean {
	if (!isHttpError(error) || error.status !== 409) {
		return false;
	}
	const code = getHttpErrorCode(error);
	return code !== undefined && ONBOARDING_CONFLICT_CODES.includes(code);
}
